import { ProductHandle } from '../../enums/ProductHandle.enum';
import { Size } from '../enums/size.enum';

export const BandSizes = [30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56] as const;
export type BandSize = typeof BandSizes[number];
export const CupSizes = ['A', 'B', 'C', 'D', 'DD/E', 'DDD/F', 'G'] as const;
export type CupSize = typeof CupSizes[number];
export type BraSize = `${BandSize}${CupSize}`;

interface Bra {
  band: BandSize;
  cup: CupSize;
}

export const convertToBraObject = (braSizeStr: BraSize | undefined): Bra | undefined => {
  const parts = braSizeStr?.match(/(\d+)(\D+)/);
  return parts && parts.length > 2 ? { band: +parts[1] as BandSize, cup: parts[2] as CupSize } : undefined;
};

export const getSuggestedTankSizeFromBraSize = (braSize: BraSize): Size => {
  switch (braSize) {
    case '30A':
    case '30B':
    case '30C':
    case '30D':
    case '32A':
    case '32B':
    case '34A':
      return Size.XS;
    case '30DD/E':
    case '30DDD/F':
    case '32C':
    case '32D':
    case '32DD/E':
    case '34B':
    case '34C':
      return Size.S;
    case '30G':
    case '32DDD/F':
    case '34D':
    case '34DD/E':
    case '36A':
    case '36B':
      return Size.M;
    case '32G':
    case '34DDD/F':
    case '34G':
    case '36C':
    case '36D':
    case '38A':
    case '38B':
    case '40A':
      return Size.L;
    case '36DD/E':
    case '36DDD/F':
    case '38C':
    case '38D':
    case '40B':
    case '42A':
      return Size.XL;
    case '36G':
    case '38DD/E':
    case '38DDD/F':
    case '40C':
    case '40D':
    case '40DD/E':
    case '42B':
    case '42C':
    case '44A':
      return Size['1X'];
    case '38G':
    case '40DDD/F':
    case '42D':
    case '42DD/E':
    case '42DDD/F':
    case '44B':
    case '44C':
    case '44D':
    case '46A':
      return Size['2X'];
    case '40G':
    case '44DD/E':
    case '44DDD/F':
    case '46B':
    case '46C':
    case '46D':
    case '46DD/E':
    case '48A':
    case '48B':
    case '48C':
    case '48D':
    case '48DD/E':
      return Size['3X'];
    case '46DDD/F':
    case '48DDD/F':
    case '50A':
    case '50B':
    case '50C':
    case '50D':
    case '50DD/E':
    case '50DDD/F':
    case '52A':
    case '52B':
    case '52C':
    case '52D':
    case '52DD/E':
    case '52DDD/F':
    case '54A':
    case '54B':
    case '54C':
    case '54D':
    case '54DD/E':
    case '54DDD/F':
    case '56A':
    case '56B':
    case '56C':
    case '56D':
    case '56DD/E':
    case '56DDD/F':
    case '42G':
    case '44G':
    case '46G':
    case '48G':
    case '50G':
    case '52G':
    case '54G':
    case '56G':
    default:
      return Size['?'];
  }
};

export const getSuggestedCamiSizeFromBraSize = (braSize: BraSize): Size => {
  switch (braSize) {
    case '30A':
    case '30B':
    case '30C':
    case '30D':
    case '32A':
    case '32B':
    case '34A':
      return Size.XS;
    case '30DD/E':
    case '30DDD/F':
    case '32C':
    case '32D':
    case '32DD/E':
    case '34B':
    case '34C':
      return Size.S;
    case '30G':
    case '32DDD/F':
    case '34D':
    case '34DD/E':
    case '36A':
    case '36B':
      return Size.M;
    case '32G':
    case '34DDD/F':
    case '34G':
    case '36C':
    case '36D':
    case '38A':
    case '38B':
    case '40A':
      return Size.L;
    case '36DD/E':
    case '36DDD/F':
    case '38C':
    case '38D':
    case '40B':
    case '42A':
      return Size.XL;
    case '36G':
    case '38DD/E':
    case '38DDD/F':
    case '40C':
    case '40D':
    case '40DD/E':
    case '42B':
    case '42C':
    case '44A':
      return Size['1X'];
    case '38G':
    case '40DDD/F':
    case '40G':
    case '42D':
    case '42DD/E':
    case '42DDD/F':
    case '44B':
    case '44C':
    case '44D':
    case '46A':
      return Size['2X'];
    case '42G':
    case '44DD/E':
    case '44DDD/F':
    case '44G':
    case '46B':
    case '46C':
    case '46D':
    case '46DD/E':
    case '46DDD/F':
    case '48A':
    case '48B':
    case '48C':
    case '48D':
    case '50A':
      return Size['3X'];
    case '46G':
    case '48DD/E':
    case '48DDD/F':
    case '48G':
    case '50B':
    case '50C':
    case '50D':
    case '50DD/E':
    case '50DDD/F':
    case '52B':
    case '52C':
    case '52D':
    case '52DD/E':
    case '52DDD/F':
      return Size['4X'];
    case '50G':
    case '52A':
    case '52G':
    case '54A':
    case '54B':
    case '54C':
    case '54D':
    case '54DD/E':
    case '54DDD/F':
    case '54G':
    case '56A':
    case '56B':
    case '56C':
    case '56D':
    case '56DD/E':
    case '56DDD/F':
    case '56G':
    default:
      return Size['?'];
  }
};

export const upsizeBraCup = (braSize: BraSize | undefined): Bra | undefined => {
  if (braSize === undefined) {
    return undefined;
  }
  const bra = convertToBraObject(braSize);
  switch (bra?.cup) {
    case 'A':
      return { cup: 'B', band: bra.band };
    case 'B':
      return { cup: 'C', band: bra.band };
    case 'C':
      return { cup: 'D', band: bra.band };
    case 'D':
      return { cup: 'DD/E', band: bra.band };
    case 'DD/E':
      return { cup: 'DDD/F', band: bra.band };
    case 'DDD/F':
    case 'G':
      return { cup: 'G', band: bra.band };
    default:
      return bra?.cup;
  }
};

export const downsizeBraCup = (braSize: BraSize | undefined): Bra | undefined => {
  if (braSize === undefined) {
    return undefined;
  }
  const bra = convertToBraObject(braSize);
  switch (bra?.cup) {
    case 'A':
    case 'B':
      return { cup: 'A', band: bra.band };
    case 'C':
      return { cup: 'B', band: bra.band };
    case 'D':
      return { cup: 'C', band: bra.band };
    case 'DD/E':
      return { cup: 'DD/E', band: bra.band };
    case 'DDD/F':
      return { cup: 'DDD/F', band: bra.band };
    case 'G':
      return { cup: 'DDD/F', band: bra.band };
  }

  return bra;
};

export const toBraSize = (bra: Bra | undefined): BraSize | undefined => {
  return bra ? `${bra.band}${bra.cup}` : undefined;
};

export const upsizeBraBand = (braSize: BraSize | undefined, handle: ProductHandle): Bra | undefined => {
  if (braSize === undefined) {
    return undefined;
  }
  const bra = convertToBraObject(braSize);

  if (!bra?.band || bra.band >= maxBandSize(handle)) {
    return undefined;
  }

  return {
    band: (bra.band + 2) as BandSize,
    cup: bra.cup,
  };
};

export const downsizeBraBand = (braSize: BraSize | undefined, handle: ProductHandle): Bra | undefined => {
  if (braSize === undefined) {
    return undefined;
  }
  const bra = convertToBraObject(braSize);

  if (!bra?.band || bra.band <= minBandSize(handle)) {
    return undefined;
  }

  return {
    band: (bra.band - 2) as BandSize,
    cup: bra.cup,
  };
};

export const camiBodysuitBraSize = (braSize: BraSize): Size | undefined => camiBodysuitBraChart[braSize];

const camiBodysuitBraChart: { [braSize in BraSize]: Size | undefined } = {
  '30A': Size['XS'],
  '30B': Size['XS'],
  '30C': Size['XS'],
  '30D': Size['XS'],
  '30DD/E': Size.S,
  '30DDD/F': Size.S,
  '30G': Size.M,
  '32A': Size['XS'],
  '32B': Size['XS'],
  '32C': Size['S'],
  '32D': Size['S'],
  '32DD/E': Size['S'],
  '32DDD/F': Size['M'],
  '32G': Size['L'],
  '34A': Size['XS'],
  '34B': Size['S'],
  '34C': Size['S'],
  '34D': Size['M'],
  '34DD/E': Size['M'],
  '34DDD/F': Size['L'],
  '34G': Size['L'],
  '36A': Size['M'],
  '36B': Size['M'],
  '36C': Size['L'],
  '36D': Size['L'],
  '36DD/E': Size['XL'],
  '36DDD/F': Size['XL'],
  '36G': Size['1X'],
  '38A': Size['L'],
  '38B': Size['L'],
  '38C': Size['XL'],
  '38D': Size['XL'],
  '38DD/E': Size['1X'],
  '38DDD/F': Size['1X'],
  '38G': Size['2X'],
  '40A': Size['L'],
  '40B': Size['XL'],
  '40C': Size['1X'],
  '40D': Size['1X'],
  '40DD/E': Size['1X'],
  '40DDD/F': Size['2X'],
  '40G': Size['3X'],
  '42A': Size['XL'],
  '42B': Size['1X'],
  '42C': Size['1X'],
  '42D': Size['2X'],
  '42DD/E': Size['2X'],
  '42DDD/F': Size['2X'],
  '42G': undefined,
  '44A': Size['1X'],
  '44B': Size['2X'],
  '44C': Size['2X'],
  '44D': Size['2X'],
  '44DD/E': Size['3X'],
  '44DDD/F': Size['3X'],
  '44G': undefined,
  '46A': Size['2X'],
  '46B': Size['3X'],
  '46C': Size['3X'],
  '46D': Size['3X'],
  '46DD/E': Size['3X'],
  '46DDD/F': Size['3X'],
  '46G': Size['4X'],
  '48A': Size['3X'],
  '48B': Size['3X'],
  '48C': Size['3X'],
  '48D': Size['3X'],
  '48DD/E': Size['4X'],
  '48DDD/F': Size['4X'],
  '48G': Size['4X'],
  '50A': Size['3X'],
  '50B': Size['4X'],
  '50C': Size['4X'],
  '50D': Size['4X'],
  '50DD/E': Size['4X'],
  '50DDD/F': Size['4X'],
  '50G': undefined,
  '52A': undefined,
  '52B': Size['4X'],
  '52C': Size['4X'],
  '52D': Size['4X'],
  '52DD/E': Size['4X'],
  '52DDD/F': Size['4X'],
  '52G': undefined,
  '54A': undefined,
  '54B': undefined,
  '54C': undefined,
  '54D': undefined,
  '54DD/E': undefined,
  '54DDD/F': undefined,
  '54G': undefined,
  '56A': undefined,
  '56B': undefined,
  '56C': undefined,
  '56D': undefined,
  '56DD/E': undefined,
  '56DDD/F': undefined,
  '56G': undefined,
};

export const tankBodysuitBraSize = (braSize: BraSize): Size | undefined => tankBodysuitBraChart[braSize];

const tankBodysuitBraChart: { [braSize in BraSize]: Size | undefined } = {
  '30A': Size['XS'],
  '30B': Size['XS'],
  '30C': Size['XS'],
  '30D': Size['XS'],
  '30DD/E': Size.S,
  '30DDD/F': Size.S,
  '30G': Size.M,
  '32A': Size['XS'],
  '32B': Size['XS'],
  '32C': Size['S'],
  '32D': Size['S'],
  '32DD/E': Size['S'],
  '32DDD/F': Size['M'],
  '32G': Size['L'],
  '34A': Size['XS'],
  '34B': Size['S'],
  '34C': Size['S'],
  '34D': Size['M'],
  '34DD/E': Size['M'],
  '34DDD/F': Size['L'],
  '34G': Size['L'],
  '36A': Size['M'],
  '36B': Size['M'],
  '36C': Size['L'],
  '36D': Size['L'],
  '36DD/E': Size['XL'],
  '36DDD/F': Size['XL'],
  '36G': Size['1X'],
  '38A': Size['L'],
  '38B': Size['L'],
  '38C': Size['XL'],
  '38D': Size['XL'],
  '38DD/E': Size['1X'],
  '38DDD/F': Size['1X'],
  '38G': Size['2X'],
  '40A': Size['L'],
  '40B': Size['XL'],
  '40C': Size['1X'],
  '40D': Size['1X'],
  '40DD/E': Size['1X'],
  '40DDD/F': Size['2X'],
  '40G': Size['3X'],
  '42A': Size['XL'],
  '42B': Size['1X'],
  '42C': Size['1X'],
  '42D': Size['2X'],
  '42DD/E': Size['2X'],
  '42DDD/F': Size['2X'],
  '42G': undefined,
  '44A': Size['1X'],
  '44B': Size['2X'],
  '44C': Size['2X'],
  '44D': Size['2X'],
  '44DD/E': Size['3X'],
  '44DDD/F': Size['3X'],
  '44G': undefined,
  '46A': Size['2X'],
  '46B': Size['3X'],
  '46C': Size['3X'],
  '46D': Size['3X'],
  '46DD/E': Size['3X'],
  '46DDD/F': undefined,
  '46G': undefined,
  '48A': Size['3X'],
  '48B': Size['3X'],
  '48C': Size['3X'],
  '48D': Size['3X'],
  '48DD/E': Size['3X'],
  '48DDD/F': undefined,
  '48G': undefined,
  '50A': undefined,
  '50B': undefined,
  '50C': undefined,
  '50D': undefined,
  '50DD/E': undefined,
  '50DDD/F': undefined,
  '50G': undefined,
  '52A': undefined,
  '52B': undefined,
  '52C': undefined,
  '52D': undefined,
  '52DD/E': undefined,
  '52DDD/F': undefined,
  '52G': undefined,
  '54A': undefined,
  '54B': undefined,
  '54C': undefined,
  '54D': undefined,
  '54DD/E': undefined,
  '54DDD/F': undefined,
  '54G': undefined,
  '56A': undefined,
  '56B': undefined,
  '56C': undefined,
  '56D': undefined,
  '56DD/E': undefined,
  '56DDD/F': undefined,
  '56G': undefined,
};

export const minBandSize = (handle: ProductHandle): BandSize => {
  const sizes = supportedBandSizes(handle);
  return sizes[0];
};

export const maxBandSize = (handle: ProductHandle): BandSize => {
  const sizes = supportedBandSizes(handle);
  return sizes[sizes.length - 1];
};

export const supportedBandSizes = (handle: ProductHandle): BandSize[] => {
  switch (handle) {
    case ProductHandle.SuperPowerShort:
    case ProductHandle.SuperPowerShortV2:
    case ProductHandle.SuperPowerBrief:
    case ProductHandle.SuperPowerThong:
    case ProductHandle.QueenBrief:
    case ProductHandle.WaistHeroCincher:
      return BandSizes.filter((bs) => bs >= 30 && bs <= 50);
    case ProductHandle.LiftWearCami:
    case ProductHandle.CamiBodysuit:
      return [30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52];
    default:
      return [30, 32, 34, 36, 38, 40, 42, 44, 46, 48];
  }
};

export const unsupportedBandSizes = (handle: ProductHandle): BandSize[] => {
  switch (handle) {
    case ProductHandle.SuperPowerShort:
    case ProductHandle.SuperPowerShortV2:
    case ProductHandle.SuperPowerBrief:
    case ProductHandle.SuperPowerThong:
    case ProductHandle.QueenBrief:
    case ProductHandle.WaistHeroCincher:
      return [];
    case ProductHandle.LiftWearCami:
    case ProductHandle.CamiBodysuit:
      return [54, 56];
    default:
      return [50, 52, 54, 56];
  }
};
